import Vue from "vue";
import * as Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import app from "./app";
import errors from "./errors";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: { app, errors },
  plugins: [createPersistedState({ paths: ["app"] })]
});
